export const requiredRule = (v: string | number | null | undefined) =>
    (v !== null && v !== undefined && String(v).trim() !== '') || 'Pole wymagane';
